import { IDSRDeleteResponse } from './dsr.interface';

type DSRStatus = IDSRDeleteResponse;

export const dsrRemoveServiceStatus = (source: DSRStatus[], target: DSRStatus) => {
    if (!source || !Array.isArray(source)) return [];
    return source.filter((request) => request.serviceUuid !== target.serviceUuid);
};

export const dsrUpdateStatuses = (source: DSRStatus[], target: DSRStatus) => {
    const filtered = dsrRemoveServiceStatus(source, target);
    filtered.push(target);
    return filtered;
};
